/** Pseudo permission the platform provider grants to owners and admins (`MANAGING_ROLES`). */
export const MANAGE = 'platform.manage';
